<div #originRef (click)="showPopover(originRef)" [class.bg-hover]="dropdownOpen"
  class="flex items-center rounded cursor-pointer relative trans-ease-out select-none py-1 pr-1 pl-3 hover:bg-hover"
  matRipple>
  <div class="body-1 font-medium leading-snug ltr:mr-3 rtl:ml-3 hidden sm:block">{{user.name}}</div>
  <div class="image-Square-round h-9 w-9 flex items-center justify-center text-primary bg-primary/10">
    <img [src]="user.imageSrc" class="avatar h-9 w-9 align-middle image-Square-round">
  </div>
</div>
 